import React, { Component } from "react";
import { withSnackbar } from "notistack";
import { Grid } from "@material-ui/core";
import StSearchBar from "../components/StSearchBar";
import StTable from "../components/StTable";
import { permissionCheckFnforCamo, } from "../../../../utils";
import { StTableHead } from "./StTableHead";
import { AccessDenied, EmptyCollection, PageLoader,DeletePopUp } from "../../../../shared_elements";
import StList from "../components/StList";
import { deleteSvAssetDetailRow, fillStEditFormApi, getSoftTimeApi, importStFileApi, UpdateStFormApi, uploadStFileApi, exportStListApi, DownloadAllApi, exportMasterApi,bulkDelete,onArchiveAsset} from "../apiServices";
import BasicDetailHeader from "../../BasicDetailHeader";
import { trackActivity } from "../../../../utils/mixpanel";
import SubDetails from "../../../../shared_elements/components/sub_details/SubDetails";
class SoftTimeComponent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			addFormDialog: false,
			sidebarOpen: true,
			tabIndex: 0,
			pageLoader: false,
			sort: "",
			sort_by: "",
			assetsDetail: {
				list: [],
				pagination: {},
				asset_count: {},
				new_task_last_used_folder_uuid: '',
				last_used_folder_uuid_link_document: "",
				checkbox_last_used_folder_uuid: '',
				checkbox_last_used_folder_name: ''
			},
			headerData: {},
			headerTsn: "",
			headerCsn: "",
			basicDetails:{},
			isBasicDetailExpanded: true,
			currentRecordPerPage: 250,
			uuid: "",
			slug:"",
			bulkOperation: { modal: false, ids: [], title: '', type: '' },
			archiveModal:false
		};
		this.getSoftTimeApi = getSoftTimeApi.bind(this);
		this.openAddForm = this.openAddForm.bind(this);
		this.closeAddForm = this.closeAddForm.bind(this);
		this.toggleSidebar = this.toggleSidebar.bind(this);
		this.handleDeleteRow = deleteSvAssetDetailRow.bind(this); //done
		this.handleEditRow = fillStEditFormApi.bind(this);
		this.UpdateStFormApi = UpdateStFormApi.bind(this); //done
		this.uploadStFileApi = uploadStFileApi.bind(this); //done
		this.importStFileApi = importStFileApi.bind(this); //done
		this.downloadAllApi = DownloadAllApi.bind(this);
		this.exportStListApi = exportStListApi.bind(this);
		this.exportMasterApi = exportMasterApi.bind(this);
		this.bulkDelete = bulkDelete.bind(this);
		this.onArchiveAsset = onArchiveAsset.bind(this);
	}

	componentDidMount() {
		this.getData();
		this.pullData();
		trackActivity('Soft Time Page Visited - CAMO', {
			event_type: 'Page Visited',
			page_title: 'Soft Time',
		})
	}
	pullData = (slug,tsn, csn,) => {
		this.setState({ slug: slug });
		this.setState({ headerTsn: tsn });
		this.setState({ headerCsn: csn });
		
	};
	uuidData = (uuid) => {
		this.setState({ uuid: uuid });
	}


	getData(item) {
		this.getSoftTimeApi({ per_page: this.state.currentRecordPerPage }, "skeletonLoader", this.props, item ? item : null);
	}
	openAddForm() {
		this.setState({ addFormDialog: true });
	}
	closeAddForm() {
		this.setState({ addFormDialog: false });
	}

	toggleSidebar() {
		this.setState({ sidebarOpen: !this.state.sidebarOpen });
	}
	createSortHandler = (sortField) => {
		const { sort, sort_by, filter, tabIndex, assetsDetail } = this.state;
		this.setState({
			sort: sortField,
			sort_by:
				sortField === sort ? (sort_by === "asc" ? "desc" : "asc") : "desc",
		})
		if (sortField === sort) {
			if (sort_by === "asc") {
				this.getSoftTimeApi({ ...filter, sort: sortField, sort_by: "desc", per_page: assetsDetail.pagination.per_page, asset_type: tabIndex, }, "pageLoader", this.props);
			} else {
				this.getSoftTimeApi({ ...filter, sort: sortField, sort_by: "asc", per_page: assetsDetail.pagination.per_page, asset_type: tabIndex, }, "pageLoader", this.props);
			}
		} else {
			this.getSoftTimeApi({ ...filter, sort: sortField, sort_by: "asc", per_page: assetsDetail.pagination.per_page, asset_type: tabIndex, }, "pageLoader", this.props);
		}
	};
	searchResults = (item) => {
		if (item !== null) {
			this.getData(item);
		}
	};

	updateFormData = async (updateId, updatedData, props,openForm,closeForm) => {
		await this.UpdateStFormApi(updateId, updatedData, props, this.state.currentRecordPerPage,openForm,closeForm);
	};

	fileUploadData = async (uploadId, formdata, props, haveAttachments) => {
		await this.uploadStFileApi(uploadId, formdata, props, this.state.currentRecordPerPage, haveAttachments);
	};

	importFile = (formData, props, isXLSX) => {
		this.importStFileApi(formData, props, isXLSX, this.state.currentRecordPerPage);
	};

	exportAssetDetailListFunc = (props) => {
		const { basicDetails } = this.state;
		this.exportStListApi(props, '', this.props, basicDetails);
	};

	downloadAllFilesApi = (props) => {
		this.downloadAllApi(props);
	};

	refreshComp = () => {
		this.getData();
	};
	engineType=(data)=>{
		this.setState({basicDetails:data})
	}

	toggleBulkOps = async (flag, type, item) => {
        const { bulkOperation, assetsDetail } = this.state;   
        try {
            if (type === 'bulk') {
                const response = await this.getSoftTimeApi(
                    { per_page: flag ? assetsDetail?.pagination?.total : this.state.currentRecordPerPage},
                    "skeletonLoader",
                    this.props,
                    null
                );
                this.setState({
                    bulkOperation: { ...bulkOperation, type: 'bulk', ids: flag ? response?.data?.results : [] }
                });
            } else {
                this.setState({
                    bulkOperation: {
                        ...bulkOperation,
                        type: 'single',
                        ids: flag ? [...bulkOperation.ids, item] : bulkOperation.ids.filter(optionItem => optionItem.id !== item.id)
                    }
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }

	render() {
		const { tabIndex, sort, sort_by, assetsDetail, pageLoader, uuid,slug,bulkOperation,basicDetails ,archiveModal, isBasicDetailExpanded} = this.state;
		return (
			<section className="amp-listing-section">
				{pageLoader ? <PageLoader /> : null}
				<Grid className="mt-0" spacing={3} container>
					<Grid className="pt-0 pr-0" xs={12} item>
						<SubDetails
							masterExport={true}
							title="Soft Time"
							slug={slug}
							module='st'
							match={this.props?.match}
							onRefresh={this.refreshComp}
							permissionCheck={permissionCheckFnforCamo({ primaryKey: "ad_status", keyIndex: "U" })}
						/>
						<BasicDetailHeader props={this.props} func={this.pullData} uuid={this.uuidData}  engineType={this.engineType} module='st' onAccordionChange={(expanded) => this.setState({ isBasicDetailExpanded: expanded })} />
						{permissionCheckFnforCamo({
							primaryKey: "ad_status",
							keyIndex: "R",
						}) ? (
							<div className="custom-border">
								<StSearchBar
									currentRecordPerPage={this.state.currentRecordPerPage}
									tabIndex={tabIndex}
									pageLoader={"pageLoader"}
									props={this.props}
									uuid={uuid}
									assetsDetail={assetsDetail?.list}
									basicDetails={basicDetails}
									importFile={this.importFile}
									getResponseBack={this.refreshComp}
									fileUploadData={this.fileUploadData}
									searchData={(e) => this.searchResults(e.target.value)}
									exportReportFn={(file) =>
										this.exportAssetDetailListFunc(
											{
												download: file.extension,
											},
											"pageLoader"
										)
									}
								/>
								<StTable
									currentRecordPerPage={this.state.currentRecordPerPage}
									heads={StTableHead}
									sort={sort}
									sort_by={sort_by}
									basicDetails={basicDetails}
									isBasicDetailExpanded={isBasicDetailExpanded}
									bulkDeletefn={()=>this.bulkDelete(this.props,bulkOperation, assetsDetail.pagination.per_page,)}
                                    bulkOperation={bulkOperation}
                                    bulkFlag={assetsDetail?.list?.length === bulkOperation?.ids?.length && assetsDetail?.list?.length > 0}
                                    toggleBulkOps={(flag) => this.toggleBulkOps(flag, 'bulk')}
									data={assetsDetail?.list?.map((item, index) => (
										<StList
										    bulkOperation={bulkOperation}
                                            toggleBulkOps={(flag) => this.toggleBulkOps(flag, 'single', item)}
											currentRecordPerPage={this.state.currentRecordPerPage}
											key={index}
											item={item}
											uuid={uuid}
											basicDetails={basicDetails}
											assetsDetail={assetsDetail}
											getResponseBack={this.refreshComp}
											last_used_folder_uuid={assetsDetail.new_task_last_used_folder_uuid}
											last_used_folder_uuid_link_document={assetsDetail.last_used_folder_uuid_link_document}
											checkbox_last_used_folder_uuid={assetsDetail.checkbox_last_used_folder_uuid}
											checkbox_last_used_folder_name={assetsDetail.checkbox_last_used_folder_name}
											index={index}
											handleDeleteRow={(data) =>
												this.handleDeleteRow(
													item,
													this.props,
													this.state.currentRecordPerPage
												)
											}
											updateFormData={this.updateFormData}
											handleEditRow={(data) =>
												this.handleEditRow(item, this.props)
											}
											props={this.props}
											fileUploadData={this.fileUploadData}
											downloadAllApi={(file) =>
												this.downloadAllFilesApi(
													{
														download: file.extension,
														...{
															asset_type: tabIndex,
															item,
														},
													},

													"pageLoader"
												)
											}
										/>
									))}
									createSortHandler={this.createSortHandler}
									pagination={assetsDetail.pagination}
									onChangePage={(event, newPage) =>
										this.getSoftTimeApi({
												asset_type: this.state.tabIndex,
											    per_page: assetsDetail.pagination.per_page,
											    page: newPage + 1,
											},
											"pageLoader",
											this.props
										)
									}
										onChangeRowsPerPage={(event) =>
											this.setState(
												{ currentRecordPerPage: event.target.value },
												() => {
													this.getSoftTimeApi({
														asset_type: this.state.tabIndex,
														per_page: this.state.currentRecordPerPage,

													},
														"pageLoader",
														this.props
													);
												}
											)
										}
									noRecord={
										assetsDetail?.list?.length ? null : !this.state.pageLoader ? (
											<EmptyCollection title="No Records Found" />
										) : null
									}
								/>
							</div>
						) : (
							<AccessDenied />
						)}
					</Grid>
				</Grid>
				{
                    archiveModal ?
                        <DeletePopUp
                            title='Archive Asset'
                            deleteRecordFn={() => this.onArchiveAsset(this.props, slug)}
                            modal={() => this.setState({ archiveModal: true })}
                            content='Are you sure, you want to Archive?'
                            toggleModalFn={() => this.setState({ archiveModal: false })}
                            confirmText="ARCHIVE"
                        />
                        : null
                }
			</section>
		);
	}
}
export default withSnackbar(SoftTimeComponent);
